/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FuelUpPrestigeActionResponsePrestigeResult
 */
export interface FuelUpPrestigeActionResponsePrestigeResult {
    /**
     * 
     * @type {boolean}
     * @memberof FuelUpPrestigeActionResponsePrestigeResult
     */
    prestiged?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FuelUpPrestigeActionResponsePrestigeResult
     */
    newLevel?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpPrestigeActionResponsePrestigeResult
     */
    fuelSacrificed?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof FuelUpPrestigeActionResponsePrestigeResult
     */
    bonusesUnlocked?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FuelUpPrestigeActionResponsePrestigeResult
     */
    gameStateReset?: boolean;
}

/**
 * Check if a given object implements the FuelUpPrestigeActionResponsePrestigeResult interface.
 */
export function instanceOfFuelUpPrestigeActionResponsePrestigeResult(value: object): value is FuelUpPrestigeActionResponsePrestigeResult {
    return true;
}

export function FuelUpPrestigeActionResponsePrestigeResultFromJSON(json: any): FuelUpPrestigeActionResponsePrestigeResult {
    return FuelUpPrestigeActionResponsePrestigeResultFromJSONTyped(json, false);
}

export function FuelUpPrestigeActionResponsePrestigeResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpPrestigeActionResponsePrestigeResult {
    if (json == null) {
        return json;
    }
    return {
        
        'prestiged': json['prestiged'] == null ? undefined : json['prestiged'],
        'newLevel': json['newLevel'] == null ? undefined : json['newLevel'],
        'fuelSacrificed': json['fuelSacrificed'] == null ? undefined : json['fuelSacrificed'],
        'bonusesUnlocked': json['bonusesUnlocked'] == null ? undefined : json['bonusesUnlocked'],
        'gameStateReset': json['gameStateReset'] == null ? undefined : json['gameStateReset'],
    };
}

export function FuelUpPrestigeActionResponsePrestigeResultToJSON(json: any): FuelUpPrestigeActionResponsePrestigeResult {
    return FuelUpPrestigeActionResponsePrestigeResultToJSONTyped(json, false);
}

export function FuelUpPrestigeActionResponsePrestigeResultToJSONTyped(value?: FuelUpPrestigeActionResponsePrestigeResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prestiged': value['prestiged'],
        'newLevel': value['newLevel'],
        'fuelSacrificed': value['fuelSacrificed'],
        'bonusesUnlocked': value['bonusesUnlocked'],
        'gameStateReset': value['gameStateReset'],
    };
}

